"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactionToNextPaint = void 0;
var _attribution = require("web-vitals/attribution");
var _vitalMetric = require("./vital-metric");
var _constants = require("./constants");
var _runtime = require("../constants/runtime");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const interactionToNextPaint = exports.interactionToNextPaint = new _vitalMetric.VitalMetric(_constants.VITAL_NAMES.INTERACTION_TO_NEXT_PAINT);
if (_runtime.isBrowserScope) {
  /* Interaction-to-Next-Paint */
  (0, _attribution.onINP)(({
    value,
    attribution,
    id
  }) => {
    const attrs = {
      metricId: id,
      eventTarget: attribution.interactionTarget,
      // event* attrs deprecated in v4, kept for NR backwards compatibility
      eventTime: attribution.interactionTime,
      // event* attrs deprecated in v4, kept for NR backwards compatibility
      interactionTarget: attribution.interactionTarget,
      interactionTime: attribution.interactionTime,
      interactionType: attribution.interactionType,
      inputDelay: attribution.inputDelay,
      nextPaintTime: attribution.nextPaintTime,
      processingDuration: attribution.processingDuration,
      presentationDelay: attribution.presentationDelay,
      loadState: attribution.loadState
    };
    interactionToNextPaint.update({
      value,
      attrs
    });
  });
}